import React from 'react'

const SecondOptions = (props) => {

    const buttons = [
        {
            label:'Flight Status',
            handler: props.actionProvider.handleFlightStatus,
            id: 1,
        },
        {
            label: 'Book a Trip',
            handler: props.actionProvider.handleBookATrip,
            id: 2,
        },
        {
            label: 'Find Hotels',
            handler: props.actionProvider.handleFindHotels,
            id: 3,
        },
        {
            label: 'Packing Tips',
            handler: props.actionProvider.handlePackingTips,
            id: 4,
        },
        {
            label: 'Flight Deals',
            handler:props.actionProvider.handleFlightDeals,
            id: 5,
        },
        {
            label: 'Vehicle Rentals',
            handler: props.actionProvider.handleVehicleRentals,
            id: 6,
        },
        {
            label: 'Find Vacation Spots',
            handler: props.actionProvider.handleVacationSpots,
            id: 7,
        },
        {
            label: 'Register',
            handler:props.actionProvider.handleRegister,
            id: 8,
        },
    ];
  return (
    <div className='options-container'>
    {buttons.map((button) => (
      <button key={button.id} onClick={button.handler}className="option-button">
          {button.label}
      </button>
  ))}
  </div>
  )
}

export default SecondOptions
